import React from 'react';
import {Link} from 'react-router-dom';
import {Card, Col, List, Row, Typography} from 'antd';
import dayjs from "dayjs";

import BookingAddIncrement from './BookingAddIncrement';
import BookingEnd from './BookingEnd';
import {isWithinGracePeriod} from '../../helpers/booking';
import {getTimeDiff} from '../../helpers/misc';
import {useAppSelector} from "../../hooks/useStore";
import {dayNameDateTimeFormat} from '../../lib/time';
import {selectIsStaff} from "../../store/slices/userSlice";
import {BookingListProps} from '../../types/bookingTypes';

import './BookingList.less'
import {bookingListGridStyle} from '../../assets/styles';

const {Text} = Typography;

const BookingList = ({loading, bookings, paginationParam, onBookingUpdate}: BookingListProps) => {
    const isStaff = useAppSelector(selectIsStaff);

    return (
        <List
            id="booking-list"
            className="list-pagination-bottom"
            grid={bookingListGridStyle}
            loading={loading}
            dataSource={bookings}
            pagination={paginationParam}
            renderItem={({booking_created_at, booking_deployment, booking_location, booking_number, deployable, id}) => {
                const startTime = booking_deployment.started_at ? dayjs(booking_deployment.started_at).tz().format(dayNameDateTimeFormat) : 'N/A';
                const endTime = booking_deployment.ended_at ? dayjs(booking_deployment.ended_at).tz().format(dayNameDateTimeFormat) : 'N/A';
                const duration = (booking_deployment.started_at && booking_deployment.ended_at) ? getTimeDiff(booking_deployment.started_at, booking_deployment.ended_at) : 'N/A';

                const isBookingWithinGracePeriod = isWithinGracePeriod(booking_created_at);
                const isBookingCancelled = booking_deployment.state === 'CANCELLED';
                const isBookingCurrent = (
                    dayjs().tz().isAfter(booking_deployment.started_at) &&
                    dayjs().tz().isBefore(booking_deployment.ended_at) &&
                    booking_deployment.state !== 'CANCELLED'
                );

                return (
                    <List.Item>
                        <Card title={
                            <>
                                <span>Booking #</span>
                                <Link to={`/booking/${id}`}>{booking_number}</Link>
                            </>
                        }>
                            <Link className="booking-list-linked-card" to={`/booking/${id}`}>
                                <Row>
                                    <Col xs={20} md={15}><Text strong>Status:</Text></Col>
                                    <Col xs={24} md={10} className={isBookingCancelled ? "booking-list-cancelled-booking" : "booking-list-confirmed-booking"}>{booking_deployment.state.toLowerCase()}</Col>
                                </Row>
                                <Row>
                                    <Col xs={20} md={15}><Text strong>Car:</Text></Col>
                                    <Col xs={24}>{deployable.description}</Col>
                                </Row>
                                <Row>
                                    <Col xs={20} md={15}><Text strong>Location:</Text></Col>
                                    <Col xs={24}>{booking_location.description}</Col>
                                </Row>
                                <Row>
                                    <Col xs={20}><Text strong>Start Time:</Text></Col>
                                    <Col xs={24} md={20}>{startTime}</Col>
                                </Row>
                                <Row>
                                    <Col xs={20}><Text strong>End Time:</Text></Col>
                                    <Col xs={24} md={20}>{endTime}</Col>
                                </Row>
                                <Row>
                                    <Col xs={20}><Text strong>Duration:</Text></Col>
                                    <Col xs={24} md={20}>{duration}</Col>
                                </Row>
                            </Link>
                            <div className="booking-list-adjustment-container">
                            {isBookingCurrent &&
                                <Row className="booking-list-increment-component">
                                    <Col xs={24} md={20}>
                                        <BookingAddIncrement
                                            bookingID={id}
                                            bookingDetails={{
                                                state: booking_deployment.state,
                                                started_at: booking_deployment.started_at,
                                                ended_at: booking_deployment.ended_at,
                                            }}
                                            onBookingUpdate={onBookingUpdate}
                                        />
                                    </Col>
                                </Row>
                            }
                            {(isBookingCurrent && (!isBookingWithinGracePeriod || isStaff)) &&
                                <Row>
                                    <Col xs={24} md={20}>
                                        <BookingEnd bookingID={id} />
                                    </Col>
                                </Row>
                            }
                            </div>
                        </Card>
                    </List.Item>
                );
            }}
        />
    )
};

export default BookingList;
